import { user_click_item_header } from 'store/actions';
import { Store } from 'store/store';
import { WEAPONS } from '../constants';
import Boxes from './Boxes';

const Weapons = () => {
  const dispatch = Store.useDispatch();

  return (
    <>
      <div className="grid-item grid-hr">Weapons</div>

      {WEAPONS.map(({ name }) => [
        // Weapon Header
        <div
          key={name}
          className="grid-item"
          onClick={() => dispatch(user_click_item_header(name))}
        >
          {name}
        </div>,

        // Boxes
        <Boxes key={name + '-boxes'} name={name} />,
      ])}
    </>
  );
};

export default Weapons;
